module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"ArticleMenu":{"ariaLabel":"Kategorie rádců","title":"Kategorie rádců"}}}')
  delete Component.options._Ctor
}
